import ColorsProps from './ColorsProps'

let KendoArcGaugeColor = {
    name: 'kendo-arcgauge-color',
    render () {
        return null
    },
    mixins: [ColorsProps]
}

export default KendoArcGaugeColor



// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoArcGauge/KendoArcGaugeColor.js